import { makeStyles } from "@fluentui/react-components";

export const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    padding: "20px",
  },
  progressSection: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
});
